(function(args) { 

    var datepickerId = 'datepicker-'+ args.id;

    var x = new Date()
    var offset = x.getTimezoneOffset() * 60 * 1000;

    const dateToTimestamp = (jQuery('#form_events_field_date_to').val() !== '0') ? ((jQuery('#form_events_field_date_to').val() * 1000) + offset) : null;
    const dateTo = (dateToTimestamp) ? (new Date(dateToTimestamp)) : null;

    document.getElementById(args.id).innerHTML = `
        <div class="form-field search-filter events-search-filter search-filter-date events-search-filter-date-to">
            <input type="text" id="${datepickerId}" placeholder="End Date" />
            <span class="input-span">
                <span class="icons-svg icons-svg-calendar"></span>
            </span>         
            <span class="datepicker-clear">&times;</span>
        </div>`;

    document.addEventListener('DOMContentLoaded', function() {

        jQuery('#' + datepickerId).datepicker({
            dateFormat:'dd-MM-yy',
            defaultDate: dateTo,
            
            onSelect: function(dateText, inst) {    
                if (dateText) {
                    const selectedDate = new Date(dateText);
                    const newDateTo = selectedDate.getTime();
             
                    jQuery('#form_events_field_date_to').val((newDateTo - offset) / 1000);
                } else {
                    jQuery('#form_events_field_date_to').val(0);
                }
            
              }
        });

        jQuery('#' + datepickerId).datepicker("setDate", dateTo);

        jQuery(".events-search-filter-date-to .datepicker-clear").on("click", function () {
          jQuery('#' + datepickerId).val("").datepicker("setDate", null);
          jQuery('#form_events_field_date_to').val(0);
        });

    });

})(args);